import useRecognitions, { RECOGNITIONS_PAGE_SIZE } from "@/src/hooks/features/rewardly/use-recognitions";
import { ActivityIndicator, View } from "react-native";
import ScPagination from "../../ui-kit/pagination";
import SeasonToolbar from "../season-toolbar";
import RecognitionsTable from "./recognitions-table";

const AllRecognitions = () => {
  const {
    search, handleSearch,
    selectedSeasonId, handleSeasonChange,
    seasonOptions,
    isCurrentSeason,
    transactions, isLoading,
    totalItems, totalPages, currentPage, handlePageChange,
    handleDelete, isDeleting,
    handleExport, isExporting,
  } = useRecognitions();

  if (isLoading) {
    return (
      <View className="flex-1 justify-center items-center py-12">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  return (
    <View className="flex-1 flex-col gap-4">
      <SeasonToolbar
        search={search}
        onSearchChange={handleSearch}
        seasonOptions={seasonOptions}
        selectedSeasonId={selectedSeasonId}
        onSeasonChange={handleSeasonChange}
        isCurrentSeason={isCurrentSeason}
        onExport={handleExport}
        isExporting={isExporting}
      />

      <RecognitionsTable
        transactions={transactions}
        onDelete={handleDelete}
        isDeleting={isDeleting}
      />

      {totalItems > 0 && (
        <ScPagination
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={RECOGNITIONS_PAGE_SIZE}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      )}
    </View>
  );
};

export default AllRecognitions;
